import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-top-bar-notice',
  templateUrl: './top-bar-notice.component.html',
  styleUrls: ['./top-bar-notice.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonIcon, TranslateModule],
})
export class TopBarNoticeComponent {
  public readonly labelKey = input('general.pending_documentation');
  public readonly noticeClick = output<void>();
}
